import React, { useRef, useEffect, useState } from "react";
import { formatDate as formatDateWithTimezone } from "../../services/functions";
import { usePlantContext } from "../../context/plantContext";
import { useUserDetail } from "../../services/hooks";
import "./Geofence.css";
import delivery from "../../Images/delivery.png";
import NavigationIcon from "@mui/icons-material/Navigation";
const GoogleMapPreview = ({ markerPosition, tripCheckpoints, factoryCoordinatesValue }) => {
	const { timezone } = usePlantContext();
	const formatDate = (date, format) => formatDateWithTimezone(date, format, timezone);
	const mapRef = useRef(null);
	const [isMapLoaded, setIsMapLoaded] = useState(true);
	const [mapInstance, setMapInstance] = useState(null);
	const { userDetail } = useUserDetail();
	// console.log("tripCheckpoints", tripCheckpoints, factoryCoordinatesValue, markerPosition)
	markerPosition = factoryCoordinatesValue?.[0] || markerPosition;
	const currentInfoWindow = useRef(null); // Ref to keep track of the current info window

	// const getCheckpointColor = (tripCheckpoints) => {
	// 	const checkpointMap = {};
	// 	let checkpointColor = "#FF0000";
	// 	// Normalize names by removing "(optional)"
	// 	const getCheckpointName = (name) => name.replace(/\s*\(optional\)/, "");

	// 	// First pass: Build checkpoint groups
	// 	tripCheckpoints.forEach((checkpoint, index) => {
	// 	  const name = getCheckpointName(checkpoint.name);

	// 	  if (!checkpointMap[name]) {
	// 		checkpointMap[name] = {
	// 		  occurrences: [],
	// 		  allVisited: true,
	// 		  anyVisited: false,
	// 		  lastVisitedIndex: -1,
	// 		  futureOccurrencesExist: false,
	// 		};
	// 	  }

	// 	  checkpointMap[name].occurrences.push({ ...checkpoint, index });

	// 	  if (checkpoint.visited) {
	// 		checkpointMap[name].anyVisited = true;
	// 		checkpointMap[name].lastVisitedIndex = index;
	// 	  } else {
	// 		checkpointMap[name].allVisited = false;
	// 	  }
	// 	});

	// 	// Determine if future occurrences exist after a visited checkpoint
	// 	Object.values(checkpointMap).forEach((group) => {
	// 	  if (group.anyVisited) {  // <-- NEW FIX: Only check if any visit occurred
	// 		for (let i = 0; i < group.occurrences.length; i++) {
	// 		  if (group.occurrences[i].visited) {
	// 			for (let j = i + 1; j < group.occurrences.length; j++) {
	// 			  if (!group.occurrences[j].visited) {
	// 				group.futureOccurrencesExist = true;
	// 				break;
	// 			  }
	// 			}
	// 		  }
	// 		}
	// 	  }
	// 	});

	// 	// Second pass: Assign colors
	// 	return tripCheckpoints.map((checkpoint) => {
	// 	  const name = getCheckpointName(checkpoint.name);
	// 	  const group = checkpointMap[name];

	// 	  if (group.occurrences.length === 1) {
	// 		checkpointColor = checkpoint.visited ? "green" : "red";
	// 		return checkpointColor
	// 		// return { ...checkpoint, color: checkpoint.visited ? "green" : "red" };
	// 	  }

	// 	  if (group.allVisited) {
	// 		// return { ...checkpoint, color: "green" };
	// 		checkpointColor='green'
	// 		return checkpointColor
	// 	  }

	// 	  // NEW FIX: Only mark orange if at least one occurrence was visited
	// 	  if (group.anyVisited && group.futureOccurrencesExist) {
	// 		// return { ...checkpoint, color: "orange" };
	// 		checkpointColor="orange"
	// 		return checkpointColor
	// 	  }

	// 	//   return { ...checkpoint, color: "red" };
	// 	return  checkpointColor
	// 	});
	//   };

	const getCheckpointColor = (tripCheckpoints) => {
		const checkpointMap = {};
		let checkpointColor = "#FF0000"; // Default color

		// Normalize names by removing "(optional)"
		const getCheckpointName = (name) => name?.replace(/\s*\(optional\)/, "");

		// First pass: Build checkpoint groups
		tripCheckpoints.forEach((checkpoint, index) => {
			const name = getCheckpointName(checkpoint.name);

			if (!checkpointMap[name]) {
				checkpointMap[name] = {
					occurrences: [],
					allVisited: true,
					anyVisited: false,
					lastVisitedIndex: -1,
					futureOccurrencesExist: false,
				};
			}

			checkpointMap[name].occurrences.push({ ...checkpoint, index });

			if (checkpoint.visited) {
				checkpointMap[name].anyVisited = true;
				checkpointMap[name].lastVisitedIndex = index;
			} else {
				checkpointMap[name].allVisited = false;
			}
		});

		// Determine if future occurrences exist after a visited checkpoint
		Object.values(checkpointMap).forEach((group) => {
			if (group.anyVisited) {
				for (let i = 0; i < group.occurrences.length; i++) {
					if (group.occurrences[i].visited) {
						for (let j = i + 1; j < group.occurrences.length; j++) {
							if (!group.occurrences[j].visited) {
								group.futureOccurrencesExist = true;
								break;
							}
						}
					}
				}
			}
		});

		// Second pass: Assign colors
		const isLastVisited = tripCheckpoints.find((cp) => cp.lastVisited === true);
		for (const checkpoint of tripCheckpoints) {
			const name = getCheckpointName(checkpoint.name);
			const group = checkpointMap[name];
			if (isLastVisited?.lastVisited) {
				checkpointColor = "blue";
				return checkpointColor;
			}
			if (group.occurrences.length === 1) {
				checkpointColor = checkpoint.visited ? "green" : "red";
				return checkpointColor;
			}

			if (group.allVisited) {
				checkpointColor = "green";
				return checkpointColor;
			}

			if (group.anyVisited && group.futureOccurrencesExist) {
				checkpointColor = "orange";
				return checkpointColor;
			}
		}

		return checkpointColor;
	};

	useEffect(() => {
		if (!window.google || !mapRef.current) {
			setIsMapLoaded(false);
			return;
		}

		try {
			const map = new window.google.maps.Map(mapRef.current, {
				center: markerPosition,
				zoom: 13,
			});
			setMapInstance(map); // Store the map instance

			const marker = new window.google.maps.Marker({
				position: markerPosition,
				map: map,
				visible: false,
			});

			// Draw factory boundary polygon
			const factoryPolygon = new google.maps.Polygon({
				paths: factoryCoordinatesValue,
				strokeColor: "#FF0000",
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: "#FF0000",
				fillOpacity: 0.35,
			});
			factoryPolygon.setMap(map);

			// Group trip details by latitude and longitude
			const groupedCheckpoints = tripCheckpoints.reduce((acc, cp) => {
				const key = `${cp.position.lat}-${cp.position.lng}`; // Use lat and lng as the key
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(cp); // Add trip details to the group
				return acc;
			}, {});

			// Create markers for each checkpoint group
			Object.keys(groupedCheckpoints).forEach((key) => {
				const checkpoints = groupedCheckpoints[key];

				const firstCheckpoint = checkpoints[0];

				const checkpointColor = getCheckpointColor(checkpoints, tripCheckpoints);
				// Create the circle icon marker
				const circleMarker = new google.maps.Marker({
					position: firstCheckpoint.position,
					map: map,
					title: firstCheckpoint.name,
					icon: {
						path: google.maps.SymbolPath.CIRCLE,
						fillColor: checkpointColor,
						fillOpacity: 1,
						scale: 10,
						strokeColor: "#FFFFFF",
						strokeWeight: 2,
					},
				});

				// Use a Set to track unique IDs
				const uniqueIds = new Set();

				// Create info window content for all unique trip details at this position
				const infoWindowContent = checkpoints
					.filter((cp) => {
						if (!uniqueIds.has(cp.id)) {
							uniqueIds.add(cp.id); // Add ID to the Set
							return true; // Include this checkpoint in the info window
						}
						return false; // Skip duplicates
					})

					.map((cp, index) => {
						// Check if the name contains the word "optional"
						const isOptional = cp?.name?.toLowerCase().includes("optional");
						const asterisk = isOptional ? "" : "*"; // Add asterisk if not optional

						// Format each checkpoint detail with a numbered list
						return `
              <div style="font-family: Arial, sans-serif; font-size: 14px;">
                ${index === 0 ? `<h4 style="margin: 0 0 10px;">${cp.name}</h4>` : ""}
                                     
                <div style="margin-bottom: 5px;">
                  <strong> ${index + 1}${asterisk}:Vehicle Number:</strong> ${cp.details.vehicleNumber || "-"}
                </div>
                <div style="margin-bottom: 5px;">
                  <strong>In Time:</strong> ${cp.details.inTime ? formatDate(cp.details.inTime) : "-"}
                </div>
                <div style="margin-bottom: 5px;">
                  <strong>Out Time:</strong> ${cp.details.outTime ? formatDate(cp.details.outTime) : "-"}
                </div>
              </div>
              <hr>
            `;
					})
					.join("");

				const infoWindow = new google.maps.InfoWindow({
					content: infoWindowContent,
				});

				circleMarker.addListener("click", () => {
					// Close the previous info window if it's open
					if (currentInfoWindow.current) {
						currentInfoWindow.current.close();
					}

					// Set the current info window
					currentInfoWindow.current = infoWindow;

					// Open the new info window
					infoWindow.open(map, circleMarker);
				});

				circleMarker.addListener("click", () => {
					infoWindow.open(map, circleMarker);
				});

				// If it's a truck checkpoint, create a truck icon next to the circle
				const lastVisitedCheckpoint = checkpoints.find((cp) => cp.lastVisited === true);
				if (lastVisitedCheckpoint) {
					const offsetPosition = {
						lat: lastVisitedCheckpoint.position.lat,
						lng: lastVisitedCheckpoint.position.lng + 0.0001,
					};

					const truckMarker = new google.maps.Marker({
						position: offsetPosition,
						map: map,
						title: `${firstCheckpoint.name} - Truck`,
						icon: {
							url: "/delivery.png",
							scaledSize: new google.maps.Size(40, 40),
						},
					});
					truckMarker.addListener("click", () => {
						// Close the previous info window if it's open
						if (currentInfoWindow.current) {
							currentInfoWindow.current.close();
						}

						// Set the current info window
						currentInfoWindow.current = infoWindow;

						// Open the new info window
						infoWindow.open(map, truckMarker);
					});
					truckMarker.addListener("click", () => {
						infoWindow.open(map, truckMarker);
					});
				}
			});

			// Draw connecting arrows between checkpoints
			const lineSymbol = {
				path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
				scale: 3,
			};

			const paths = [];
			if (tripCheckpoints) {
				tripCheckpoints.forEach((el, index) => {
					if (index < tripCheckpoints.length - 1) {
						paths.push({
							path: [el.position, tripCheckpoints[index + 1].position],
							pathcolor: el.visited && tripCheckpoints[index + 1].visited ? "green" : "red",
						});
					}
				});
			}

			paths.forEach((path) => {
				console.log("PATH", path)
				const line = new google.maps.Polyline({
					path: path.path,
					icons: [
						{
							icon: lineSymbol,
							offset: "100%",
						},
					],
					strokeColor: path.pathcolor,
					strokeOpacity: 0.6,
					strokeWeight: 2,
				});
				line.setMap(map);
			});
		} catch (error) {
			console.error("Error loading Google Map:", error);
			setIsMapLoaded(false);
		}
	}, [markerPosition, tripCheckpoints]);

	// Re-center the map when button is clicked
	const recenterMap = () => {
		if (mapInstance) {
			mapInstance.setCenter(markerPosition);
			mapInstance.setZoom(13); // Optional: Reset zoom level to the default
		}
	};

	return isMapLoaded ? (
		<>
			<div ref={mapRef} style={{ width: "100%", height: "500px" }} />
			<button className="recenter-button" onClick={recenterMap}>
				<NavigationIcon />
				Re-center
			</button>
			<div className="map-icons-detail">
				<div className="map-icon">
					<div className="redDot"></div>
					<div className="map-icon-description">Never visited</div>
				</div>
				<div className="map-icon">
					<div className="greenDot"></div>
					<div className="map-icon-description">Point is covered</div>
				</div>
				<div className="map-icon">
					<div className="orangeDot"></div>
					<div className="map-icon-description">Visited atleast once</div>
				</div>
				<div className="map-icon">
					<div className="truck">
						<img src={delivery} alt="delivery" height="24px" width="24px" />
					</div>
					<div className="map-icon-description">Current Position</div>
				</div>
				<div className="map-icon">
					<div className="green-arrow"></div>
					<div className="map-icon-description">Path covered</div>
				</div>
				<div className="map-icon">
					<div className="red-arrow"></div>
					<div className="map-icon-description">Path expected to be cover</div>
				</div>
			</div>
		</>
	) : (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "500px",
				backgroundColor: "#f0f0f0",
				color: "#666",
				fontSize: "18px",
				fontFamily: "Arial, sans-serif",
			}}
		>
			No Map Available
		</div>
	);
};

export default GoogleMapPreview;
